<template>
  <div class="yoyo-container mx-auto min-h-screen relative">
    <QueryHeader @search="loadData" @date-change="handleDateChange" @input="handleInput" :iccid="iccid" />

    <!-- 表头（固定在外层容器顶部） -->
    <div class="mx-4 w-[calc(100%-2rem)] mt-3">
      <div class="grid grid-cols-3 gap-2 text-md font-medium text-gray-700 bg-white z-10 h-10 leading-10">
        <div class="text-center">{{ $t("query.date") }}</div>
        <div class="text-center">{{ $t("query.country") }}</div>
        <!-- <div class="text-center">{{ $t("query.status") }}</div> -->
        <div class="text-center">{{ $t("query.usage") }}</div>
      </div>
    </div>

    <!-- 列表容器 -->
    <div class="mx-4 w-[calc(100%-2rem)] absolute top-70 bottom-18 overflow-y-auto">
      <van-list
      v-if="list.length > 0"
        v-model="loading"
        :finished="finished"
        :finished-text="$t('query.noMoreData')"
        :loading-text="$t('query.loading')"
        @load="onLoad">
        <!-- 数据列表 -->
        <div class="bg-white rounded-b-lg overflow-hidden h-full">
          <div
            v-for="(item, index) in list"
            :key="item.id"
            :class="['py-3 border-b border-gray-100 grid grid-cols-3 gap-2 text-sm', index % 2 === 0 ? 'bg-gray-50' : 'bg-white']">
            <div class="text-center text-gray-800">{{ item.date }}</div>
            <div class="text-center flex items-center justify-center">
              <span class="text-gray-800">{{ item.country }}</span>
            </div>
            <!-- <div class="text-center">{{ item.status }}</div> -->
            <div class="text-center">{{ item.usage }}</div>
          </div>
        </div>
      </van-list>
      <div v-if="list.length > 0">
        <div>
          {{ $t("query.alreadyUsed") }}{{ extra.total }}
        </div>
        <div class="text-sm text-gray-500 mt-1">
          {{ $t("query.tip") }}
        </div>
      </div>
      <van-empty v-else :description="$t('common.noData')" />
    </div>

    <div class="fixed h-14 bottom-0 left-0 right-0 pb-[env(safe-area-inset-bottom)] container mx-auto">
      <div class="flex items-center h-full justify-center w-full lg:mx-4 lg:w-[calc(100%-2rem)]" v-if="extra.bind === 0">
        <van-button type="danger" class="w-44 h-9 rounded-xl" color="#ff7a00" @click="handleBind">
          {{ $t("query.bindToAccount") }}
        </van-button>
      </div>
      <div class="flex items-center h-full justify-center w-full lg:mx-4 lg:w-[calc(100%-2rem)]" v-if="extra.canRecharge === 1">
        <van-button type="danger" class="w-38 h-9 rounded-xl" color="#ff7a00" @click="handleRecharge">
          {{ $t("recharge.title") }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import QueryHeader from "@/components/query/Header.vue"
import { PullRefresh, List, Toast } from "vant"
import { queryUsage, addBinding } from "@/apis/mine"
import dayjs from "dayjs"

export default {
  name: "Query",
  components: {
    QueryHeader,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
  },
  data() {
    return {
      // 列表相关数据
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 1,
      pageSize: 10,

      // 模拟数据
      mockData: [],
      iccid: "",
      startTime: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
      endTime: dayjs().format("YYYY-MM-DD"),
      extra: {},
    }
  },
  methods: {
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        active: this.$t("query.statusActive"),
        expired: this.$t("query.statusExpired"),
        pending: this.$t("query.statusPending"),
      }
      return statusMap[status] || status
    },

    // 下拉刷新
    onRefresh() {
      // this.pageNo = 1
      // this.finished = false
      // this.list = []
      // this.loadData()
    },

    // 上拉加载
    onLoad() {
      this.pageNo += 1
      this.loadData()
    },
    handleDateChange(date) {
      console.log("date :>> ", date)
      this.startTime = date.split(" - ")[0]
      this.endTime = date.split(" - ")[1]
      this.loadData()
    },
    // 加载数据
    loadData() {
      const req = {
        iccid: this.iccid,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        startTime: this.startTime,
        endTime: this.endTime,
      }
      queryUsage(req)
        .then((res) => {
          const list = res.data.list || []
          if (this.pageNo === 1) {
            this.list = list
            this.refreshing = false
          } else {
            this.list = [...this.list, ...list]
          }
          this.extra = res.data.extra
          this.loading = false

          // 判断是否已加载完所有数据
          if (res.data.total >= this.list.length) {
            this.finished = true
          } else {
            this.pageNo++
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    handleInput(value) {
      this.iccid = value
    },

    goToCart() {
      this.$router.push("/cart")
    },

    // 立即购买按钮点击事件
    handleBind() {
      addBinding({ iccid: this.iccid })
        .then((res) => {
          Toast.success(this.$t("binds.addBindingSuccess"))
          this.loadData()
        })
        .catch((error) => {
          console.log("添加绑定失败:", error)
        })
    },
    handleRecharge() {
      // 跳转到充值页面
      this.$router.push({ path: "/rechargeDetail", query: { id: 10000000142, type: "SIM", iccid: this.iccid } })
    },
  },

  created() {
    console.log(this.$route.query.iccid)
    this.iccid = this.$route.query.iccid
    // 初始化加载数据
    this.iccid && this.loadData()
  },
}
</script>

<style scoped></style>
